<div class="login-form col-12 mx-auto" *ngIf="!loginLocked">
  <div class="col-10 text-center mb-4">
    <i class="pi pi-user mr-2" style="font-size: 1.5rem"></i>
    <span id="login-enterCredentials"> <b translate> Login.Enter Credentials </b></span>
  </div>

  <form #loginForm="ngForm" validate>
    <div class="row">
      <div class="offset-1 col-8">
        <label class="d-block mb-2 mx-5">
          <input pInputText id="login-userName"
                 name="username"
                 #username="ngModel"
                 [(ngModel)]="loginData.username"
                 type="email"
                 class="form-control text-center"
                 autocomplete="username"
                 placeholder="{{ 'Common.Username' | translate }}"
                 minlength="7"
                 maxlength="100"
                 [pattern]="patternUniqueEmail"
                 required
          />

          <small id="login-userNameError" *ngIf="username.touched && username.errors?.minlength" class="text-danger" translate>
            {{ 'Length Maximum Minimum Login' | translate:{ quantityMax: 100, quantityMin: 7 } }}
          </small>
          <small id="login-requiredLogin" *ngIf="!username.errors?.minlength && username.errors?.required && username.touched" class="text-danger" translate>
            Generic Errors.Required Login
          </small>
          <small id="login-patternLogin" *ngIf="username.errors?.pattern" class="text-danger" translate> Login.Login Pattern </small>
        </label>
        <label class="d-block mb-3 mx-5">
          <input pInputText id="login-password"
                 name="password"
                 #password="ngModel"
                 [(ngModel)]="loginData.password"
                 type="password"
                 class="form-control text-center"
                 autocomplete="current-password"
                 placeholder="{{ 'Common.Password' | translate }}"
                 minlength="8"
                 maxlength="100"
                 required
          />

          <small id="login-passwordError" *ngIf="password.touched && password.errors?.minlength" class="text-danger" translate>
            {{ 'Length Maximum Minimum Password' | translate:{ quantityMax: 100, quantityMin: 8 } }}
          </small>
          <small id="login-genericErrors" *ngIf="!password.errors?.minlength && password.errors?.required && password.touched" class="text-danger" translate>
            Generic Errors.Required Password
          </small>
        </label>
      </div>
      <div class="col-3">
        <div class="mt-4">
          <p-button severity="primary" icon="pi pi-sign-in" iconPos="right" label="{{ 'Login.Log In' | translate }}"
                    [loading]="isLoading && !firstLoginSuccess" (click)="login()" [disabled]="loginForm.invalid || isLoading || showMFAInfo || firstLoginSuccess">
          </p-button>
        </div>
      </div>
    </div>
  </form>

  <div class="row mb-3" *ngIf="firstLoginSuccess">
    <div class="offset-1 col-8 mt-2 justify-content-center text-center">
      <div class="row">
        <span translate> Login.Enter MFA Code </span>
      </div>
      <div class="row">
        <div class="offset-4 col-4">
          <input pInputText id="login-mfaCode"
                 name="mfaCode"
                 #mfaCode="ngModel"
                 [(ngModel)]="loginData.mfaCode"
                 type="text"
                 class="form-control text-center"
                 autocomplete="off"
                 minlength="6"
                 maxlength="6"
                 [pattern]="patternMfaCode"
                 required
          />
        </div>
        <div class="col-1">
          <p-button link="true" severity="primary" icon="fa-2x fa-solid fa-circle-info" tooltipPosition="bottom"  pTooltip="{{ 'Login.Information.Microsoft Info' | translate }}" class="mt-2" (click)="toggleShowMFAInformation(true)"></p-button>
        </div>
        <small id="login-mfaCodeError" *ngIf="mfaCode.touched && mfaCode.errors?.pattern" class="text-danger" translate>
          Login.Errors.Invalid MFA Code
        </small>
      </div>
    </div>
    <div class="col-3 mt-3">
      <p-button severity="primary" icon="fa-regular fa-circle-check" label="{{ 'Login.Verify' | translate }}" class="mt-2" id="login-loginButton"
                (click)="login()"  [loading]="isLoading && firstLoginSuccess" [disabled]="mfaCode.invalid"> </p-button>
    </div>
  </div>
</div>

<div class="foot-form row">
  <div class="offset-1 col-4 text-right">
    <span class="text-center mb-2" id="login-forgotPasswordSection" *ngIf="!loginLocked">
      <small id="login-forgotPasswordText" [hidden]="hideForgot">
        <a id="login-forgotPassword" (click)="forgotPassword()" class="text-info" translate> Login.Forgot Password </a>
      </small>
    </span>
  </div>
  <div class="col-4 text-left">
    <span class="text-center" id="login-contactUsSection">
      <small id="login-contactUsText" [hidden]="hideForgot">
        <a id="login-contactUs" (click)="getContactUsEmails()" class="text-info" translate> Login.Contact Us </a>
      </small>
    </span>
  </div>
  <div class="col-3 d-flex justify-content-center" *ngIf="!loginLocked">
    <div id="login-navbarResponsive" class="d-flex">
      <i *ngIf="language == 'en-US'" tooltipPosition="bottom"  pTooltip="{{ 'Login.Information.Change Language' | translate }}" class="pl-1 mt-3 fa-solid fa-earth-americas"></i>
      <i *ngIf="language == 'es-ES'" tooltipPosition="bottom"  pTooltip="{{ 'Login.Information.Change Language' | translate }}" class="pl-1 mt-3 fa-solid fa-earth-europe"></i>
      <p-select id="login-language-dropdown" class="ml-2" [options]="languagesList" optionValue="keyValue" [(ngModel)]="language" (click)="setLanguage(language)" optionLabel="keyValue" />
    </div>
  </div>
</div>
